import {useEffect} from 'react';
import styled from 'styled-components';
import {useRefetchMe} from '@/api/session';
import {NavBar} from '@/components/NavBar';
import {
  CouponHistory,
  CurrentPlan,
  PayHistory,
  PayMethod,
} from '@/components/Payments';
import {Typography} from '@/components/Typography';
import {useBreakpoints} from '@/hooks';
import {HorizontalFullContainer, PageContentWide, ScrollBody} from '@/styled-components';

const PayInfo = () => {
  const {isMobile} = useBreakpoints();
  const refetchMe = useRefetchMe();

  useEffect(() => {
    refetchMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HorizontalFullContainer>
      <NavBar />
      <ScrollBody>
        <Content>
          <Typography variant={isMobile ? 'bold18' : 'bold24'}>
            이용 이력
          </Typography>
          <CurrentPlan />
          <PayMethod />
          <PayHistory />
          <CouponHistory />
        </Content>
      </ScrollBody>
    </HorizontalFullContainer>
  );
};

export default PayInfo;

const Content = styled(PageContentWide)`
  gap: 24px;
`;
